var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlz(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white",
    fillOpacity: 0.06
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6 7.15H7.04999V7.65H14.1L13.6 7.15Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.04999 8.45V7.95H14.45L14.9 8.45H7.04999Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.09999 8.75H7.04999V9.35H9.09999V8.75Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.09999 9.6H7.04999V10.25H9.09999V9.6Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2 8.75H12.85L12.9 8.85L13 8.95L13.1 9.05L13.2 9.15V9.25V9.4H15.25L15.2 8.75Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.25 9.6H13.2V9.85L13.1 10L13 10.15L15.25 10.2V9.6Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2 10.35H7.09998V11.05H14.5L15.2 10.35Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.09998 11.85V11.25L14.5 11.2L15.1 11.85H7.09998Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.09998 12.8V12.1H9.14998V12.8H7.09998Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M7.09998 13.55V12.95H9.14998V13.55H7.09998Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2 12.05H12.9L13.1 12.35L13.2 12.5V12.75H15.2V12.05Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2 12.85H13.2V13.1L13.1 13.25L12.85 13.55H15.2V12.85Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.04999 14.35V13.8L15.15 13.75L14.5 14.35H7.04999Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7 15.1L14.25 14.6L7.04999 14.55V15.15L13.7 15.1Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4 7.7V7H18.55V7.7H16.4Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M18.55 7.9H16.4V8.55H18.55V7.9Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 8.75H16.4V9.35H18.5V8.75Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 9.55H16.4V10.25H18.5V9.55Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 10.4H16.4V11.1H18.5V10.4Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 11.25H16.4V11.9H18.5V11.25Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 12.05H16.4V12.7H18.5V12.05Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6 12.85H16.4V13.55H19.25L18.6 12.85Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2 14.4L16.6 13.75H24.55V14.4H17.2Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1 15.15L17.4 14.55H24.55V15.15H18.1Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2 16.6H13.1V17.3H15.2V16.6Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2 17.45H13.1V18.1H15.2V17.45Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2 18.25H13.1V18.9H15.2V18.25Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2 19.1H13.1V19.75H15.2V19.1Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2 19.9H13.1V20.55H15.2V19.9Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2 20.75H13.1V21.45H15.2V20.75Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2 21.6H13.1V22.25H15.2V21.6Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1 16.6H7V17.3H9.1V16.6Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1 17.45H7V18.1H9.1V17.45Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1 18.25H7V18.9H9.1V18.25Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1 19.1H7V19.75H9.1V19.1Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1 19.9H7V20.55H9.1V19.9Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1 20.75H7V21.45H9.1V20.75Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1 21.6H7V22.25H9.1V21.6Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3 22.4L9.9 23.05H7V22.4H9.3Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2 23.1H12.35L13.1 22.4H15.2V23.1Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 23.95L15 23.3H7.15002L7.85002 23.95H14.4Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 24.15L13.65 24.7H8.60002L8.00002 24.1L14.25 24.15Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6 18.25H16.45V18.95H18.6V18.25Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6 19.15H16.45V19.8H18.6V19.15Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M16.45 18.05V17.4H23.8L24.4 18.05H16.45Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M23 16.65L23.55 17.2L16.45 17.25V16.65H23Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M22.65 18.9L22.35 18.35L22.25 18.25H24.7V18.9H22.65Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M24.65 19.1H22.65L22.4 19.75H24.65V19.1Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 19.95H16.45V20.6H23.95L24.5 19.95Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M23.95 20.85H16.45V21.4H24.5L23.95 20.85Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M18.55 22.45H16.45V23.1H18.55V22.45Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M18.55 21.55H16.45V22.2H18.55V21.55Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7 21.55V22.25H22.7L22.4 21.55H24.7Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M24.75 22.45H22.65V23.1H24.75V22.45Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M18.55 23.25H16.45V23.9H18.55V23.25Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M24.75 23.25H22.65V23.9H24.75V23.25Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M18.55 24.05H16.45V24.7H18.55V24.05Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M24.75 24.05H22.65V24.7H24.75V24.05Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlz);
export default __webpack_public_path__ + "static/media/BLZ.9efda14a19af16ae836ab48397084791.svg";
export { ForwardRef as ReactComponent };